
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --link-font-size:var(--fs-body-sm);
  --link-color-default:var(--brand-gray-900);
  --padding-y:0.625rem;
  font-size:var(--body-font-size);
  font-family:var(--ff-body);
  color:var(--brand-gray-900);
}

ol,
.breadcrumb{
  display:flex;
  align-items:center;
  list-style:none;
  gap:var(--spacing-2);
  padding:var(--padding-y) var(--padding-x);
}

li{
  display:flex;
  align-items:center;
  gap:var(--spacing-2);
}

.first a{
  --link-margin-x:-0.1875rem;
  --link-padding-x:0.1875rem;
  padding-top:0.1875rem;
  padding-bottom:0.1875rem;
  border-bottom:0;
}

.separator{
  width:8px;
  transform:rotate(180deg);
}

@media (min-width: 768px){

.separator{
    transform:none
}
  }

.last{
  transform:translateY(1px);
  display:flex;
}

.last .separator{
    display:none;
  }
`;